import React from 'react';

import useBuilderConstructorGridInputs from '../hooks/useBuilderConstructorGridInputs';

import MobileGridFilters from './MobileGridFilters/MobileGridFilters';
import MobileGridSortDropdown from './MobileGridSortDropdown';

const MobileGridHeader = () => {
  const { gridHeader } = useBuilderConstructorGridInputs();

  return (
    <div>
      <h1 className="font-bold text-[24px]">{gridHeader}</h1>
      <div className="flex justify-between items-center mt-[16px] mb-[24px]">
        <MobileGridSortDropdown />
        <MobileGridFilters />
      </div>
    </div>
  );
};

export default MobileGridHeader;
